import { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import {
  Search, SlidersHorizontal, Clock, Truck, CheckCircle2, AlertCircle, X, Plus, Filter, Trash2,
  PackageCheck, Wallet, Settings, MessageCircle, AlertTriangle,
} from "lucide-react";
import NewReturnRequestModal from "./NewReturnRequestModal";
import WarrantyEmailSettingsModal from "./WarrantyEmailSettingsModal";
import WhatsAppWarrantySettingsModal from "./WhatsAppWarrantySettingsModal";
import NotificationAuditModal from "./NotificationAuditModal";
import NotificationLogModal from "./NotificationLogModal";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const STATUSES = {
  // ── Common ──
  pending: { label: "În așteptare", cls: "bg-amber-500/15 text-amber-300 border-amber-500/40", dot: "bg-amber-400", icon: Clock, accent: "from-amber-500/20 to-amber-500/5", count_cls: "text-amber-300", ring: "border-amber-500/60 ring-1 ring-amber-500/30" },
  // ── Garanție: pickup_issued → in_transit → at_service → delivery_issued → completed ──
  pickup_issued:   { label: "Preluare Client",        cls: "bg-orange-500/15 text-orange-300 border-orange-500/40", dot: "bg-orange-400", icon: Truck,        accent: "from-orange-500/20 to-orange-500/5",  count_cls: "text-orange-300",  ring: "border-orange-500/60 ring-1 ring-orange-500/30" },
  in_transit:      { label: "În drum spre service",   cls: "bg-cyan-500/15 text-cyan-300 border-cyan-500/40",       dot: "bg-cyan-400",   icon: Truck,        accent: "from-cyan-500/20 to-cyan-500/5",      count_cls: "text-cyan-300",    ring: "border-cyan-500/60 ring-1 ring-cyan-500/30" },
  at_service:      { label: "Verificare Service",     cls: "bg-violet-500/15 text-violet-300 border-violet-500/40", dot: "bg-violet-400", icon: PackageCheck, accent: "from-violet-500/20 to-violet-500/5",  count_cls: "text-violet-300",  ring: "border-violet-500/60 ring-1 ring-violet-500/30" },
  delivery_issued: { label: "În livrare către client",cls: "bg-sky-500/15 text-sky-300 border-sky-500/40",          dot: "bg-sky-400",    icon: Truck,        accent: "from-sky-500/20 to-sky-500/5",        count_cls: "text-sky-300",     ring: "border-sky-500/60 ring-1 ring-sky-500/30" },
  // ── Retur (new keys) ──
  in_transit_warehouse:        { label: "Către Depozit",                  cls: "bg-cyan-500/15 text-cyan-300 border-cyan-500/40",       dot: "bg-cyan-400",   icon: Truck,        accent: "from-cyan-500/20 to-cyan-500/5",   count_cls: "text-cyan-300",    ring: "border-cyan-500/60 ring-1 ring-cyan-500/30" },
  at_warehouse_pending_refund: { label: "În verificare, Bani de returnat",cls: "bg-violet-500/15 text-violet-300 border-violet-500/40", dot: "bg-violet-400", icon: Wallet,       accent: "from-violet-500/20 to-violet-500/5", count_cls: "text-violet-300",  ring: "border-violet-500/60 ring-1 ring-violet-500/30" },
  // ── Schimb (new keys) ──
  outbound_in_delivery: { label: "În livrare către client",    cls: "bg-sky-500/15 text-sky-300 border-sky-500/40",      dot: "bg-sky-400",     icon: Truck,        accent: "from-sky-500/20 to-sky-500/5",     count_cls: "text-sky-300",     ring: "border-sky-500/60 ring-1 ring-sky-500/30" },
  return_in_transit:    { label: "În tranzit către depozit",   cls: "bg-fuchsia-500/15 text-fuchsia-300 border-fuchsia-500/40", dot: "bg-fuchsia-400", icon: PackageCheck, accent: "from-fuchsia-500/20 to-fuchsia-500/5", count_cls: "text-fuchsia-300", ring: "border-fuchsia-500/60 ring-1 ring-fuchsia-500/30" },
  // ── Livrare (2026-08-21) ──
  in_delivery: { label: "În drum spre client", cls: "bg-sky-500/15 text-sky-300 border-sky-500/40", dot: "bg-sky-400", icon: Truck, accent: "from-sky-500/20 to-sky-500/5", count_cls: "text-sky-300", ring: "border-sky-500/60 ring-1 ring-sky-500/30" },
  // ── Comun final ──
  completed: { label: "Finalizată", cls: "bg-emerald-500/15 text-emerald-300 border-emerald-500/40", dot: "bg-emerald-400", icon: CheckCircle2, accent: "from-emerald-500/20 to-emerald-500/5", count_cls: "text-emerald-300", ring: "border-emerald-500/60 ring-1 ring-emerald-500/30" },
  // ── Legacy aliases (cereri vechi cu schema veche) ──
  awb_issued:       { label: "Preluare Client",       cls: "bg-orange-500/15 text-orange-300 border-orange-500/40", dot: "bg-orange-400", icon: Truck,         accent: "from-orange-500/20 to-orange-500/5",  count_cls: "text-orange-300",   ring: "border-orange-500/60 ring-1 ring-orange-500/30" },
  verified:         { label: "Verificare Service",    cls: "bg-violet-500/15 text-violet-300 border-violet-500/40", dot: "bg-violet-400", icon: PackageCheck,  accent: "from-violet-500/20 to-violet-500/5",  count_cls: "text-violet-300",   ring: "border-violet-500/60 ring-1 ring-violet-500/30" },
  refund_redeliver: { label: "Bani / AWB livrare",    cls: "bg-sky-500/15 text-sky-300 border-sky-500/40",          dot: "bg-sky-400",    icon: Wallet,        accent: "from-sky-500/20 to-sky-500/5",        count_cls: "text-sky-300",      ring: "border-sky-500/60 ring-1 ring-sky-500/30" },
  refunded:         { label: "Finalizată (Bani Returnați)", cls: "bg-emerald-500/15 text-emerald-300 border-emerald-500/40", dot: "bg-emerald-400", icon: Wallet, accent: "from-emerald-500/20 to-emerald-500/5", count_cls: "text-emerald-300", ring: "border-emerald-500/60 ring-1 ring-emerald-500/30" },
  product_returned: { label: "În returnare către depozit", cls: "bg-fuchsia-500/15 text-fuchsia-300 border-fuchsia-500/40", dot: "bg-fuchsia-400", icon: PackageCheck, accent: "from-fuchsia-500/20 to-fuchsia-500/5", count_cls: "text-fuchsia-300", ring: "border-fuchsia-500/60 ring-1 ring-fuchsia-500/30" },
};
const TYPES = { garantie: "Garanție", retur: "Retur", schimb: "Schimb", livrare: "Livrare" };
const PLATFORM_LABEL = {
  emag_ro_fbe: "EMAG-RO-FBE", emag_ro_bau: "EMAG-RO-BAU",
  emag_bg_fbe: "EMAG-BG-FBE", emag_bg_bau: "EMAG-BG-BAU",
  emag_hu_fbe: "EMAG-HU-FBE", emag_hu_bau: "EMAG-HU-BAU",
};
// Cards la top — un mix de statusuri principale din toate fluxurile, pentru
// vizibilitate rapidă. „În așteptare" rămâne primul.
const STAT_ORDER = ["pending", "pickup_issued", "in_transit", "at_service", "delivery_issued", "in_transit_warehouse", "at_warehouse_pending_refund", "outbound_in_delivery", "return_in_transit", "in_delivery", "completed"];

function StatCard({ statusKey, count, active, onClick }) {
  const cfg = STATUSES[statusKey];
  const Icon = cfg.icon;
  return (
    <button data-testid={`stat-${statusKey}`} onClick={onClick}
      className={`group relative flex items-center justify-between rounded-2xl border bg-gradient-to-br ${cfg.accent} px-4 py-4 text-left transition hover:scale-[1.02] ${active ? cfg.ring : "border-zinc-800 hover:border-zinc-700"}`}>
      <div className="min-w-0">
        <p className="truncate text-[10px] font-medium uppercase tracking-wider text-zinc-400">{cfg.label}</p>
        <p className={`mt-1.5 text-3xl font-bold ${cfg.count_cls}`}>{count}</p>
      </div>
      <div className={`shrink-0 rounded-xl border ${cfg.cls} p-2.5`}><Icon className="h-4 w-4" /></div>
    </button>
  );
}

export default function ReturnsWarranties() {
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [stats, setStats] = useState({ pending: 0, pickup_issued: 0, in_transit: 0, at_service: 0, delivery_issued: 0, in_transit_warehouse: 0, at_warehouse_pending_refund: 0, outbound_in_delivery: 0, return_in_transit: 0, in_delivery: 0, completed: 0, total: 0 });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [search, setSearch] = useState("");
  const [advanced, setAdvanced] = useState(false);
  const [filters, setFilters] = useState({ order_id: "", awb: "", customer_name: "", customer_phone: "", date_from: "", date_to: "", type: "" });
  const [wizardOpen, setWizardOpen] = useState(false);
  const [emailCfgOpen, setEmailCfgOpen] = useState(false);
  const [waCfgOpen, setWaCfgOpen] = useState(false);
  const [auditOpen, setAuditOpen] = useState(false);
  const [logOpen, setLogOpen] = useState(false);

  const update = (k, v) => setFilters((f) => ({ ...f, [k]: v }));

  const load = useCallback(async () => {
    setLoading(true); setError("");
    try {
      const params = {};
      if (statusFilter) params.status = statusFilter;
      if (search) params.search = search;
      if (advanced) {
        Object.entries(filters).forEach(([k, v]) => { if (v) params[k] = v; });
      }
      const r = await axios.get(`${API}/returns`, { params });
      setItems(r.data.items || []);
      setStats({ ...r.data.stats });
    } catch (e) { setError(e.response?.data?.detail || e.message); }
    finally { setLoading(false); }
  }, [statusFilter, search, advanced, filters]);

  useEffect(() => { const t = setTimeout(() => load(), 0); return () => clearTimeout(t); }, [load]);

  const handleDelete = async (id, e) => {
    e.stopPropagation();
    if (!window.confirm("Ștergi cererea? Toate atașamentele și AWB-urile asociate vor fi eliminate din această listă.")) return;
    try {
      await axios.delete(`${API}/returns/${id}`);
      setItems((it) => it.filter((x) => x.id !== id));
    } catch (er) { setError(er.response?.data?.detail || er.message); }
  };

  return (
    <div className="px-4 py-6 sm:px-6 lg:px-8" data-testid="returns-page">
      <div className="mb-6 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <h1 className="text-2xl font-semibold tracking-tight text-zinc-50">Retururi & Garanții</h1>
          <p className="text-sm text-zinc-500">Gestionează cererile de retur, garanție și schimb</p>
        </div>
        <div className="flex items-center gap-2">
          <button data-testid="warranty-email-settings-btn" onClick={() => setEmailCfgOpen(true)}
            className="inline-flex items-center gap-2 rounded-xl border border-zinc-700 bg-zinc-900 px-3 py-2.5 text-sm font-medium text-zinc-200 hover:border-zinc-600">
            <Settings className="h-4 w-4" /> Email Garanție
          </button>
          <button data-testid="warranty-whatsapp-settings-btn" onClick={() => setWaCfgOpen(true)}
            className="inline-flex items-center gap-2 rounded-xl border border-emerald-500/40 bg-emerald-500/10 px-3 py-2.5 text-sm font-medium text-emerald-200 hover:border-emerald-500/60 hover:bg-emerald-500/20">
            <MessageCircle className="h-4 w-4" /> WhatsApp Garanție
          </button>
          <button data-testid="warranty-notification-audit-btn" onClick={() => setAuditOpen(true)}
            title="Verifică ce template Email + WhatsApp e mapat la fiecare pas al fluxurilor Garanție/Retur/Schimb/Livrare"
            className="inline-flex items-center gap-2 rounded-xl border border-amber-500/40 bg-amber-500/10 px-3 py-2.5 text-sm font-medium text-amber-200 hover:border-amber-500/60 hover:bg-amber-500/20">
            <AlertTriangle className="h-4 w-4" /> Audit Notificări
          </button>
          <button data-testid="warranty-notification-log-btn" onClick={() => setLogOpen(true)}
            title="Jurnal complet cu toate trimiterile Email + WhatsApp (succes/eșec/omisă) — vezi motivul EXACT pentru fiecare eșec"
            className="inline-flex items-center gap-2 rounded-xl border border-sky-500/40 bg-sky-500/10 px-3 py-2.5 text-sm font-medium text-sky-200 hover:border-sky-500/60 hover:bg-sky-500/20">
            <Search className="h-4 w-4" /> Jurnal Trimiteri
          </button>
          <button data-testid="new-request-btn" onClick={() => setWizardOpen(true)}
            className="inline-flex items-center gap-2 rounded-xl border border-emerald-500/40 bg-gradient-to-b from-emerald-500/15 to-emerald-500/5 px-4 py-2.5 text-sm font-medium text-emerald-200 shadow-lg hover:from-emerald-500/25">
            <Plus className="h-4 w-4" /> Cerere nouă
          </button>
        </div>
      </div>

      {error && (
        <div className="mb-4 flex items-start gap-2 rounded-xl border border-rose-500/40 bg-rose-500/10 px-4 py-3 text-sm text-rose-200">
          <AlertCircle className="mt-0.5 h-4 w-4" /><span className="flex-1">{error}</span>
          <button onClick={() => setError("")}><X className="h-4 w-4" /></button>
        </div>
      )}

      <div className="mb-6 grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-5">
        {STAT_ORDER
          .filter((k) => (stats[k] || 0) > 0)  /* only show pills that have requests */
          .map((k) => (
            <StatCard key={k} statusKey={k} count={stats[k] || 0}
              active={statusFilter === k}
              onClick={() => setStatusFilter(statusFilter === k ? "" : k)} />
          ))}
        {/* If a filter is currently active but its count dropped to 0,
            still surface a "Toate" reset chip so the user isn't stuck. */}
        {statusFilter && (stats[statusFilter] || 0) === 0 && (
          <button data-testid="reset-status-filter" onClick={() => setStatusFilter("")}
            className="rounded-2xl border border-zinc-800 bg-zinc-900/40 p-3 text-xs text-zinc-300 hover:border-emerald-500/40 hover:text-emerald-200 transition">
            ← Vezi toate cererile
          </button>
        )}
      </div>

      <div className="mb-4 space-y-3 rounded-2xl border border-zinc-800 bg-zinc-950/50 p-3">
        <div className="flex flex-wrap items-center gap-2">
          <div className="flex flex-1 min-w-[260px] items-center gap-2 rounded-lg border border-zinc-800 bg-zinc-900 px-3 py-2">
            <Search className="h-4 w-4 text-zinc-500" />
            <input data-testid="returns-search" placeholder="Caută după nr.comandă, client, AWB..." value={search} onChange={(e) => setSearch(e.target.value)}
              className="flex-1 bg-transparent text-sm text-zinc-100 placeholder-zinc-600 outline-none" />
          </div>
          <label data-testid="returns-advanced-toggle" className={`inline-flex cursor-pointer items-center gap-2 rounded-lg border px-3 py-2 text-sm font-medium transition ${advanced ? "border-emerald-500/50 bg-emerald-500/10 text-emerald-200" : "border-zinc-800 bg-zinc-900 text-zinc-300 hover:border-zinc-700"}`}>
            <input type="checkbox" checked={advanced} onChange={(e) => setAdvanced(e.target.checked)} className="h-3.5 w-3.5 accent-emerald-500" />
            <SlidersHorizontal className="h-4 w-4" /> Căutare avansată
          </label>
        </div>
        {advanced && (
          <div data-testid="returns-advanced-panel" className="grid grid-cols-2 gap-2 md:grid-cols-3 lg:grid-cols-4 rounded-xl border border-emerald-500/20 bg-emerald-500/[0.03] p-3">
            <Input testId="filt-order" label="Nr. comandă" value={filters.order_id} onChange={(v) => update("order_id", v)} />
            <Input testId="filt-awb" label="AWB" value={filters.awb} onChange={(v) => update("awb", v)} />
            <Input testId="filt-cname" label="Nume client" value={filters.customer_name} onChange={(v) => update("customer_name", v)} />
            <Input testId="filt-cphone" label="Telefon client" value={filters.customer_phone} onChange={(v) => update("customer_phone", v)} />
            <div>
              <label className="block text-[10px] font-medium uppercase tracking-wider text-zinc-500">Tip</label>
              <select data-testid="filt-type" value={filters.type} onChange={(e) => update("type", e.target.value)} className="mt-1 w-full rounded-md border border-zinc-800 bg-zinc-900 px-2 py-1.5 text-xs text-zinc-100 outline-none">
                <option value="">Toate</option><option value="garantie">Garanție</option><option value="retur">Retur</option><option value="schimb">Schimb</option><option value="livrare">Livrare</option>
              </select>
            </div>
            <DateInput testId="filt-from" label="De la" value={filters.date_from} onChange={(v) => update("date_from", v)} />
            <DateInput testId="filt-to" label="Până la" value={filters.date_to} onChange={(v) => update("date_to", v)} />
          </div>
        )}
      </div>

      <div className="overflow-hidden rounded-2xl border border-zinc-800 bg-zinc-950/70">
        <div className="overflow-x-auto">
          <table className="w-full text-sm" data-testid="returns-table">
            <thead className="bg-zinc-900/60 text-left text-[10px] uppercase tracking-wider text-zinc-500">
              <tr>
                <th className="px-3 py-2.5">Nr.</th>
                <th className="px-3 py-2.5">Data</th>
                <th className="px-3 py-2.5">Client</th>
                <th className="px-3 py-2.5">Comandă</th>
                <th className="px-3 py-2.5">Tip</th>
                <th className="px-3 py-2.5">Status</th>
                <th className="px-3 py-2.5">AWB</th>
                <th className="px-3 py-2.5 text-right">Cost desfășurător (fără TVA)</th>
                <th className="px-3 py-2.5"></th>
              </tr>
            </thead>
            <tbody className="divide-y divide-zinc-800/80">
              {loading && <tr><td colSpan={9} className="px-4 py-12 text-center text-zinc-500">Se încarcă...</td></tr>}
              {!loading && items.length === 0 && (
                <tr><td colSpan={9} className="px-4 py-16 text-center">
                  <Filter className="mx-auto mb-3 h-10 w-10 text-zinc-700" />
                  <p className="text-zinc-300">Nicio cerere de retur/garanție</p>
                  <p className="mt-1 text-sm text-zinc-500">Apasă „Cerere nouă” pentru a începe.</p>
                </td></tr>
              )}
              {!loading && items.map((it) => {
                const st = STATUSES[it.status] || STATUSES.pending;
                const lastAwb = (it.awbs || [])[it.awbs?.length - 1];
                const awb = lastAwb?.number;
                return (
                  <tr key={it.id} data-testid={`return-row-${it.id}`} onClick={() => navigate(`/returns/${it.id}`)}
                    className="cursor-pointer text-zinc-200 transition hover:bg-zinc-900/50">
                    <td className="px-3 py-3 align-top">
                      <span className="font-mono text-xs font-semibold text-emerald-300">#{String(it.request_number || 0).padStart(4, "0")}</span>
                    </td>
                    <td className="px-3 py-3 align-top text-xs text-zinc-300">{it.date || "—"}</td>
                    <td className="px-3 py-3 align-top">
                      <div className="text-xs font-medium text-zinc-100">{it.customer_name || "—"}</div>
                      <div className="text-[10px] text-zinc-500">{it.customer_phone || ""}</div>
                    </td>
                    <td className="px-3 py-3 align-top">
                      {it.order_id ? (
                        <a
                          href={`/orders?order_id=${encodeURIComponent(it.order_id)}&days=365`}
                          data-testid={`return-order-link-${it.id}`}
                          onClick={(e) => { e.stopPropagation(); e.preventDefault(); navigate(`/orders?order_id=${encodeURIComponent(it.order_id)}&days=365`); }}
                          title="Deschide comanda"
                          className="font-mono text-xs text-sky-300 underline decoration-sky-500/40 underline-offset-2 hover:text-sky-200 hover:decoration-sky-400"
                        >
                          #{it.order_id}
                        </a>
                      ) : (
                        <div className="font-mono text-xs text-zinc-200">—</div>
                      )}
                      {it.platform && <div className="mt-0.5 inline-flex rounded bg-orange-500/10 px-1.5 py-0.5 font-mono text-[9px] text-orange-300">{PLATFORM_LABEL[it.platform] || it.platform}</div>}
                    </td>
                    <td className="px-3 py-3 align-top">
                      <span className="inline-flex items-center rounded-md border border-zinc-800 bg-zinc-900 px-2 py-0.5 text-[11px] text-zinc-200">{TYPES[it.type] || it.type}</span>
                    </td>
                    <td className="px-3 py-3 align-top">
                      <span className={`inline-flex items-center gap-1.5 rounded-full border px-2 py-0.5 text-[10px] font-medium ${st.cls}`}>
                        <span className={`h-1.5 w-1.5 rounded-full ${st.dot}`} />{st.label}
                      </span>
                    </td>
                    <td className="px-3 py-3 align-top">
                      {awb ? (
                        <div className="flex items-center gap-1.5">
                          <span className={`h-1.5 w-1.5 rounded-full ${st.dot}`} />
                          <span className="font-mono text-xs text-zinc-300">{awb}</span>
                          {(it.awbs?.length || 0) > 1 && <span className="text-[9px] text-zinc-500">+{it.awbs.length - 1}</span>}
                        </div>
                      ) : <span className="text-[10px] text-zinc-600">—</span>}
                    </td>
                    <td className="px-3 py-3 align-top text-right text-xs font-semibold text-zinc-100">
                      {(() => {
                        const awbs = it.awbs || [];
                        if (!awbs.length) return <span className="text-zinc-600">—</span>;
                        const billed = awbs.filter((a) => a.invoiced_cost != null);
                        const total = billed.reduce((s, a) => s + Number(a.invoiced_cost), 0);
                        const missing = awbs.length - billed.length;
                        return (
                          <div data-testid={`row-invoiced-cost-${it.id}`}>
                            <div>{billed.length ? `${total.toFixed(2)} RON` : <span className="text-zinc-600">—</span>}</div>
                            {missing > 0 && <div className="text-[9px] font-normal text-amber-400">{missing} nefacturat{missing > 1 ? "e" : ""}</div>}
                          </div>
                        );
                      })()}
                    </td>
                    <td className="px-3 py-3 align-top text-right">
                      <button data-testid={`row-delete-${it.id}`} onClick={(e) => handleDelete(it.id, e)}
                        title="Șterge cererea"
                        className="rounded-md border border-rose-500/30 bg-rose-500/10 p-1.5 text-rose-300 transition hover:bg-rose-500/20">
                        <Trash2 className="h-3.5 w-3.5" />
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        <div className="border-t border-zinc-800 px-4 py-2.5 text-xs text-zinc-500">{items.length} înregistrări</div>
      </div>

      {wizardOpen && (
        <NewReturnRequestModal
          onClose={() => setWizardOpen(false)}
          onCreated={(d) => { setWizardOpen(false); navigate(`/returns/${d.id}`); }}
        />
      )}
      {emailCfgOpen && (
        <WarrantyEmailSettingsModal onClose={() => setEmailCfgOpen(false)} />
      )}
      {waCfgOpen && (
        <WhatsAppWarrantySettingsModal onClose={() => setWaCfgOpen(false)} />
      )}
      {auditOpen && (
        <NotificationAuditModal onClose={() => setAuditOpen(false)} />
      )}
      {logOpen && (
        <NotificationLogModal onClose={() => setLogOpen(false)} />
      )}
    </div>
  );
}

function Input({ testId, label, value, onChange }) {
  return (
    <div>
      <label className="block text-[10px] font-medium uppercase tracking-wider text-zinc-500">{label}</label>
      <input data-testid={testId} value={value} onChange={(e) => onChange(e.target.value)}
        className="mt-1 w-full rounded-md border border-zinc-800 bg-zinc-900 px-2 py-1.5 text-xs text-zinc-100 outline-none" />
    </div>
  );
}
function DateInput({ testId, label, value, onChange }) {
  return (
    <div>
      <label className="block text-[10px] font-medium uppercase tracking-wider text-zinc-500">{label}</label>
      <input data-testid={testId} type="date" value={value} onChange={(e) => onChange(e.target.value)}
        className="mt-1 w-full rounded-md border border-zinc-800 bg-zinc-900 px-2 py-1.5 text-xs text-zinc-100 outline-none" />
    </div>
  );
}
